import { useState } from "react";
import { useParams } from "react-router";
import { PolicyPlanTabId, PolicyViewModel } from "./PolicyOverview.types";
import { PolicyLegacySaveModel } from "../policies/Policies.types.ts";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider";
import { useLocalStorageTab } from "@common/hooks/useLocalStorageTab";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { usePanes, useRefetchWhenPaneSaves } from "../../main/panes/usePanes";
import AddEditPolicyPane from "../addEditPolicyPane/AddEditPolicyPane";

export function usePolicyQuery(policyId: string | undefined) {
    return useDotLegalQuery<PolicyViewModel>(`/policies/${policyId}`);
}

export function usePolicyDataMapping() {
    const { policyId } = useParams<{ policyId: string }>();
    const { customerId } = useUserContext();

    const [selectedTab, setSelectedTab] = useLocalStorageTab(`policy-plan-tab-${customerId}`, policyPlanTabMapping, PolicyPlanTabId.Documents);

    const { open: openPane } = usePanes();
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showArchiveDialog, setShowArchiveDialog] = useState(false);
    const [showChangeStatusDialog, setShowChangeStatusDialog] = useState(false);
    const [showPublishDialog, setShowPublishDialog] = useState(false);
    const [selectedPolicy, setSelectedPolicy] = useState<PolicyLegacySaveModel>();

    const { isLoading, data, refetch } = usePolicyQuery(policyId);

    useRefetchWhenPaneSaves(refetch);

    function openEditPolicyPane() {
        openPane(AddEditPolicyPane, { policyId });
    }

    return {
        policyId,
        data,
        isLoading,
        openEditPolicyPane,
        showDeleteDialog,
        setShowDeleteDialog,
        showArchiveDialog,
        setShowArchiveDialog,
        showChangeStatusDialog,
        setShowChangeStatusDialog,
        showPublishDialog,
        setShowPublishDialog,
        selectedPolicy,
        setSelectedPolicy,
        refetch,
        selectedTab,
        setSelectedTab,
    };
}

const policyPlanTabMapping: Record<number, PolicyPlanTabId> = {
    0: PolicyPlanTabId.Documents,
    1: PolicyPlanTabId.Tasks,
    3: PolicyPlanTabId.VersionsHistory,
    2: PolicyPlanTabId.Sections,
    4: PolicyPlanTabId.Recipients,
};
